<script setup>
</script>

<template>
  <div class="css__text-left">
    <h2>エラー</h2>
    <p>ページの読み込みに失敗しました。</p>
    <p>サイトに一時的な負荷が掛かっているとき、ネットワーク環境が良くないときなどにこの画面が表示されることがあります。</p>
    <p>ページの再読み込みをおこなう、通信環境の良いところに移動していただく、少し時間をあけて再度接続するなどのご対応をお願いいたします。</p>
    <br>
    <p>広告ブロッカーが検知された場合もこの画面が表示されます。</p>
    <p>画面表示に不具合が生じる可能性があることや、サイト運営に支障が出ることから、広告ブロッカーまたは広告をブロックするブラウザを使用している環境では当サイトのコンテンツを閲覧・利用できません。</p>
    <p>広告ブロッカーの使用を止めていただくか、別のブラウザをご使用ください。</p>
  </div>
</template>

<style scoped>
  div {
    height: 70vh;
  }
</style>